export const languageData = [
  {
    languageId: 'french',
    locale: 'fr',
    name: 'Français',
    icon: 'ca',
  },
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us',
  },
  {
    languageId: 'german',
    locale: 'de',
    name: 'Deutsch',
    icon: 'de',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Español',
    icon: 'es',
  },
  {
    languageId: 'italian',
    locale: 'it',
    name: 'Italiano',
    icon: 'it',
  },
  {
    languageId: 'finnish',
    locale: 'fi',
    name: 'Suomi',
    icon: 'fi',
  },
  {
    languageId: 'swedish',
    locale: 'sv',
    name: 'Svenska',
    icon: 'se',
  },
  {
    languageId: 'norwegian',
    locale: 'no',
    name: 'Norsk',
    icon: 'no',
  },
];

export const flags = {
  en: '/images/flag/icons8-usa.png',
  fr: '/images/flag/icons8-canada.png',
  de: '/images/flag/icons8-germany.png',
  es: '/images/flag/icons8-spain.png',
  it: '/images/flag/icons8-italy.png',
  fi: '/images/flag/icons8-finland.png',
  sv: '/images/flag/icons8-sweden.png',
  no: '/images/flag/icons8-norway.png',
};
